export default __webpack_public_path__ + "static/media/menu.0d2db10f.svg";